<template>
  <div class="xp-font xp-bg-login flex h-full min-h-screen flex-col">
    <!-- Top bar -->
    <div class="xp-login-topbar flex h-20 items-center justify-end px-8">
      <div class="text-right text-white">
        <p class="text-2xl font-bold italic tracking-wide drop-shadow-[2px_2px_2px_rgba(0,0,0,0.5)]">
          lnxdxtf<span class="xp-text-orange not-italic">xp</span>
        </p>
        <p class="text-xs opacity-90">{{ t('xp.login.edition') }}</p>
      </div>
    </div>

    <!-- Middle -->
    <div class="flex flex-1 flex-col items-stretch justify-center gap-8 px-6 sm:flex-row sm:items-center sm:gap-0">
      <!-- Left: hint -->
      <div class="flex flex-1 flex-col items-center gap-4 text-center sm:items-end sm:pr-10 sm:text-right">
        <p class="max-w-xs text-lg text-white drop-shadow-[1px_1px_2px_rgba(0,0,0,0.6)]">
          {{ t('xp.login.hint') }}
        </p>
      </div>

      <!-- Divider -->
      <div class="xp-login-divider hidden w-[2px] self-stretch sm:block" aria-hidden="true" />

      <!-- Right: user tile -->
      <div class="flex flex-1 flex-col items-center gap-3 sm:items-start sm:pl-10">
        <button
          class="xp-user-tile"
          :aria-label="t('xp.login.loginAs', { name: t('hero.name') })"
          @click="$emit('login')"
        >
          <UserTile :size="96" />
        </button>
        <p class="text-xl text-white drop-shadow-[1px_1px_2px_rgba(0,0,0,0.6)]">
          {{ t('hero.name') }}
        </p>
        <p class="font-mono text-xs text-white/70">
          {{ t('hero.aka') }}
        </p>
        <button
          class="flex items-center gap-2 rounded border border-white/50 bg-white/10 px-3 py-1.5 text-sm text-white hover:bg-white/25"
          @click="$emit('login')"
        >
          <span aria-hidden="true">➜</span> {{ t('xp.login.login') }}
        </button>
      </div>
    </div>

    <!-- Bottom bar -->
    <div class="xp-login-bottombar flex h-16 items-center justify-between px-8">
      <button
        class="flex items-center gap-2 text-sm text-white hover:underline"
        @click="$emit('power')"
      >
        <span class="grid h-7 w-7 place-items-center rounded bg-gradient-to-b from-[#e04444] to-[#8f1616] text-base shadow" aria-hidden="true">⏻</span>
        {{ t('xp.login.turnOff') }}
      </button>
      <div class="flex items-center gap-2 text-xs text-white">
        <button
          v-for="loc in (['pt-BR', 'en'] as Locale[])"
          :key="loc"
          class="rounded border border-white/40 px-2 py-1 hover:bg-white/20"
          :class="{ 'bg-white/25 font-bold': current === loc }"
          @click="$emit('locale', loc)"
        >
          {{ loc === 'pt-BR' ? 'PT' : 'EN' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import UserTile from './UserTile.vue'
import type { Locale } from '../locales'

defineProps<{ current: Locale }>()

defineEmits<{
  login: []
  power: []
  locale: [loc: Locale]
}>()

const { t } = useI18n()
</script>
